import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './auth-context';

/**
 * Access the full auth context: state + methods.
 *
 * @example
 * ```tsx
 * function LoginButton() {
 *   const { isAuthenticated, signInWithGoogle, logout } = useAuth();
 *   return isAuthenticated
 *     ? <button onClick={logout}>Logout</button>
 *     : <button onClick={signInWithGoogle}>Sign in with Google</button>;
 * }
 * ```
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an <AuthProvider>');
  }
  return context;
}
